import { createMetricsFactory } from 'metrics-js';
import { getIsAcceptanceTest } from './metricsUtils';
export let Metrics;
export const setupMetricsFactory = namespace => {
  Metrics = createMetricsFactory(namespace, {
    dimensions: {
      isAcceptanceTest: `${getIsAcceptanceTest()}`
    }
  });
};